<template>
      <!--我的收益-->
      <div class="comments" id="earnings">
        <!-- 可提现桃花 -->
        <van-row  class="my_earnings">
          <van-col span="24" class="my_earnings_bg">
            <van-col span="24" class="my_earnings_name">{{ $t('other.Withdrawable') }}{{ $t('other.user_company') }}</van-col>
            <van-col span="24" class="my_earnings_val">{{list.income}}</van-col>
<!--            <van-col span="12" offset="6">-->

<!--              <van-button round class="my_earnings_tx" type="default">{{ $t('other.Accumulative_withdrawal')}}:{{list.income_total}}</van-button>-->
<!--            </van-col>-->
            <van-col span="12" class="my_earnings_val_type">
              <van-col span="24" class="my_earnings_val_type_name">{{ $t('column.month_coin')}}</van-col>
              <van-col span="24" class="my_earnings_val_type_coin">{{list.consumption_coin}}{{ $t('other.user_company') }}</van-col>
            </van-col>
            <van-col span="12" class="my_earnings_val_type my_earnings_val_type_bor">
              <van-col span="24" class="my_earnings_val_type_name">{{ $t('column.month_income')}}</van-col>
              <van-col span="24" class="my_earnings_val_type_coin">{{list.month_coin}}{{ $t('other.user_company') }}</van-col>
            </van-col>
          </van-col>
          <!--<van-col span="24" class="border_article"></van-col>-->
          <van-col span="22" offset="1">
            <!--  收益明细 成为月老红娘 -->
            <van-col span="24" class="my_earnings_detail" @click="returns_detailed">
               <van-col span="18" class="my_earnings_detail_name">{{ $t('column.Income_details')}}</van-col>
               <van-col span="6" class="my_earnings_detail_jt"><van-icon name="arrow" /></van-col>
             </van-col>
            <!--   <van-col span="24" class="my_earnings_detail" @click="become_matchmaker">
                <van-col span="18" class="my_earnings_detail_name">{{ $t('column.Task_completion')}}</van-col>
                <van-col span="6" class="my_earnings_detail_jt"><van-icon name="arrow" /></van-col>
              </van-col>-->
            <!-- 收益明细 按钮 -->
            <van-col span="24" v-if="is_ios">
              <van-col span="18" offset="3" class="my_earnings_detail_dh">
                <van-button type="primary" size="large" class="my_information_btn" @click="exchange"> {{ $t('other.exchange_coin')}}</van-button>
              </van-col>
              <van-col span="22" offset="1">
                <div v-html="article"></div>
              </van-col>
            </van-col>
            <van-col span="24" v-else>
              <van-col span="10" offset="7" class="my_earnings_detail_dh">
                <van-button type="primary" size="large" class="my_information_btn" @click="exchange"> {{ $t('other.exchange_coin')}}</van-button>
              </van-col>
<!--              <van-col span="10" offset="2" class="my_earnings_detail_withdrawal">-->
<!--                <van-button type="primary" size="large" class="my_information_btn" @click="click_withdrawal">{{ $t('other.Withdrawal')}}</van-button>-->
<!--              </van-col>-->
              <van-col span="22" offset="1">
                <div v-html="article"></div>
              </van-col>
            </van-col>

          </van-col>
        </van-row>
      </div>
</template>
<script>
	//请求接口组件
  import '@/assets/css/style.css'
	import axios from 'axios'
  import { judgeIosAndroid } from '@/assets/js/models.js'
	export default {
		data:function() {
			return {
				list:{},
        is_ios: false,
        article:''
			}
		},
		created: function() {
			this.convert();
      const isIos = judgeIosAndroid();
      this.is_ios = isIos ? true : false
			document.title = this.$t('title.earnings')
		},
		methods: {
      convert: function() {
             const uid = this.$route.query.uid
             const token = this.$route.query.token
             axios.get(this.baseUrlApi+"mapi/public/index.php/api/Userinfo_api/vue_earnings",{ params:{ uid:uid,token:token }}).then(res =>{
                this.list = res.data.data
                this.article = res.data.data.article
                console.log( this.list)
             })
      },
      // 成为月老红娘
      become_matchmaker:function(){
        window.location.href="bogo://become_match_maker"
      },
       // 进入提现页面
      click_withdrawal(){
        const isIos = judgeIosAndroid();
        if (isIos == true) {
          // ios传值方法postMessage（val）传值方式
          window.location.href="bogo://withdrawal_jump"
        } else {
          const uid = this.$route.query.uid
          const token = this.$route.query.token
          this.$router.push({path:'/withdrawal',query:{uid:uid, token: token }})
        }

      },
      //收益明细
      returns_detailed: function(){
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        this.$router.push({path:'/returns_detailed',query:{uid:uid, token: token }})
      },
      // 兑换
      exchange: function(){
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        this.$router.push({path:'/exchange',query:{uid:uid, token: token }})
      }
    }

	}
</script>



// WEBPACK FOOTER //
// src/components/earnings.vue